import { ChangePassword, LoginData, LoginError } from 'auth/models';
import { FetchDataError } from 'shared/http/models/fetch-data';
import { FetcherService } from 'shared/http/models/fetcher-service';
import { useFetcherService } from 'shared/http/hooks/useFetcherService';
import { ENDPOINT } from 'shared/constants/DefaultValues';

export const refreshAuthentication = async (
  accessToken: string,
  refreshToken: string,
): Promise<LoginData> => {
  const route = `${ENDPOINT}/auth/refresh`;
  const response = await fetch(route, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      accessToken,
      refreshToken,
    }),
  });
  if (!response.ok) {
    return null;
  }
  return response.json();
};

class AuthService extends FetcherService {
  private mapToLoginError(e: FetchDataError): LoginError {
    return new LoginError(e.apiError, e.statusCode);
  }

  async doLogin(username: string, password: string) {
    return this.post<LoginData>('auth/login', { username, password }).catch(
      (e: FetchDataError) => {
        throw this.mapToLoginError(e);
      },
    );
  }

  async doLogout() {
    return this.post<void>('auth/logout');
  }

  async doChangePassword(changePassword: ChangePassword) {
    return this.post<void>('usuarios/changepassword', changePassword);
  }
}

const authService = new AuthService();

export function useAuthService() {
  const { registerFetcherService } = useFetcherService();

  registerFetcherService(authService);

  return authService;
}
